'use client';

import { FC } from 'react';
import { useRouter } from 'next/navigation';

import { TEMPLATE_BASE_PATH } from '@/constants';
import { Button, Heading, Product, ProductPlaceholder } from '@/components';
import { useIsServerSide, useProductsByIds, useWishList } from '@/hooks';

interface WishlistProps {
  title?: string;
  titleLevel?: number;
}

const isProductCardLargImage =
  process?.env?.NEXT_PUBLIC_FEATURE_FLAG_PRODUCT_LARGE_IMAGE === 'true';

const Wishlist: FC<WishlistProps> = ({
  title = 'Favorite Products',
  titleLevel = 2,
}) => {
  const router = useRouter();
  const { isServerSide } = useIsServerSide();
  const { favProductsIds } = useWishList();
  const { products, isLoading } = useProductsByIds({ ids: favProductsIds });

  const goToShop = () => {
    router.push(TEMPLATE_BASE_PATH.SHOP);
  };

  return (
    <div className={'wishlist__container_account'}>
      <Heading className="wishlist_title" level={titleLevel}>
        {title}
      </Heading>
      {isLoading || isServerSide ? (
        <div className="wishlist__content">
          {new Array(20).fill(null).map((_, index) => (
            <ProductPlaceholder
              key={index}
              largeCard={isProductCardLargImage}
            />
          ))}
        </div>
      ) : !products.length ? (
        <div className="wishlist__blank_container">
          <div className="wishlist__blank">
            <div className="wishlist__blank_body">
              <span className="wishlist__blank__title">
                You have not added products to the wishlist?
              </span>
              <p>Add some items to get started</p>
            </div>
            <Button ariaLabel="Shop now" color="primary" onClick={goToShop}>
              Shop now
            </Button>
          </div>
        </div>
      ) : (
        <div className="wishlist__content">
          {products?.map(prod => {
            return (
              <Product
                className="wishlist_product"
                key={prod?.id as string}
                product={prod}
              />
            );
          })}
        </div>
      )}
    </div>
  );
};

export { Wishlist };
